// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Header_headerWrapper__tkOPg {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  transition: opacity 0.3s ease, transform 0.5s ease;
}

.Header_headerWrapper__tkOPg.Header_hidden__bI9VI {
  transform: translateY(-100%);
  opacity: 0;
}

.Header_headerWrapper__tkOPg.Header_expanded__9kFsl {
  height: auto;
  transition: none;
}

.Header_header__Lhnr8 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: rgba(0, 0, 0, 0.845);
  -webkit-backdrop-filter: blur(15px);
          backdrop-filter: blur(15px);
  padding: 10px 0;
  transition: background-color 0.3s ease, -webkit-backdrop-filter 0.3s ease;
  transition: background-color 0.3s ease, backdrop-filter 0.3s ease;
  transition: background-color 0.3s ease, backdrop-filter 0.3s ease, -webkit-backdrop-filter 0.3s ease;
}

.Header_headerWrapper__tkOPg.Header_expanded__9kFsl .Header_header__Lhnr8:not(.Header_submenuVisible__k-PId) {
  -webkit-backdrop-filter: none;
          backdrop-filter: none;
  background-color: transparent;
}

.Header_submenuVisible__k-PId {
  -webkit-backdrop-filter: blur(15px) !important;
          backdrop-filter: blur(15px) !important;
}

.Header_headerContent__WRnni {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.Header_logo__nZ7K6 {
  display: inline-flex;
  align-items: baseline;
  color: white;
  font-size: 20px;
  font-weight: bold;
  line-height: 1;
}

.Header_logoAccent__oKBRX {
  color: #4da3ff;
}

.Header_logoWord__LmzqP {
  display: inline-block;
  overflow: hidden;
  white-space: nowrap;
  line-height: 1;
  animation: Header_logoReveal__cekmW 0.7s ease-out forwards;
  transform-origin: left center;
}

@keyframes Header_logoReveal__cekmW {
  from {
    opacity: 0;
    clip-path: inset(0 100% 0 0);
    transform: translateX(-10px);
  }
  to {
    opacity: 1;
    clip-path: inset(0 0 0 0);
    transform: translateX(0);
  }
}

.Header_navContainer__Y0LlM {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-bottom: 2px;
}

.Header_navList__FI4e0 {
  list-style: none;
  display: flex;
  margin: 0;
  padding: 0;
}

.Header_navItem__woy74 {
  margin: 0px 15px;
  transition: opacity 0.3s ease;
}

.Header_navLink__v1a7F {
  color: #fff;
  text-decoration: none;
  font-size: 14px;
  transition: color 0.3s;
  cursor: pointer;
}

.Header_navItem__woy74.Header_dimmed__zveC9 .Header_navLink__v1a7F {
  color: #999;
}

.Header_navLink__v1a7F:hover {
  color: #fff;
}

.Header_navItem__woy74:hover .Header_navLink__v1a7F {
  color: #fff;
}

.Header_submenuPanel__Et6vL {
  background-color: rgba(0, 0, 0, 0);
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 99;
  transition: opacity 0.3s ease, visibility 0.3s ease;
}

.Header_submenuPanel__Et6vL:hover,
.Header_navContainer__Y0LlM:hover {
  visibility: visible;
  opacity: 1;
}

.Header_submenuPanel__Et6vL.Header_visible__jJT3\\+ {
  visibility: visible;
  opacity: 1;
}

.Header_headerWrapper__tkOPg.Header_expanded__9kFsl:hover + .Header_content-wrapper__BTI-b {
  transform: translateY(50px);
}

.Header_submenuContent__gO5TN {
  display: flex;
  justify-content: space-between;
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
  padding: 20px;
  animation: Header_slideIn__qNk38 0.3s ease-in-out;
}

.Header_submenuColumn__gc\\+LL {
  flex: 1 1;
  padding: 0 15px;
}

.Header_submenuColumn__gc\\+LL h3 {
  color: #fff;
  font-size: 14px;
  margin-bottom: 10px;
  font-weight: bold;
}

.Header_submenuColumn__gc\\+LL ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.Header_submenuColumn__gc\\+LL li {
  margin-bottom: 8px;
}

.Header_submenuColumn__gc\\+LL a {
  color: #ccc;
  text-decoration: none;
  font-size: 14px;
  transition: color 0.3s;
}

.Header_submenuColumn__gc\\+LL a:hover {
  color: #fff;
}

.Header_ctaButton__rqx4i {
  background-color: var(--color-text);
  color: var(--color-background);
  border: none;
  border-radius: 25px;
  padding: var(--space-xs) var(--space-sm);
  font-size: var(--font-size-small);
  cursor: pointer;
  transition: background-color 0.3s, color 0.3s;
}

.Header_ctaButton__rqx4i:hover {
  background-color: var(--color-text-subtle);
  color: var(--color-background);
}

.Header_hamburger__gyFYw {
  display: none;
  flex-direction: column;
  justify-content: space-around;
  width: 25px;
  height: 20px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  z-index: 110;
  position: absolute;
  top: 15px; /* Adjust as needed */
  right: 20px; /* Adjust as needed */
}

.Header_closeIcon__P5RSh {
  z-index: 2000; /* Ensure it is above the drawer */
}

.Header_hamburgerIcon__b8hAl {
  width: 100%;
  height: 2px;
  background-color: white;
  transition: all 0.3s linear;
}

.Header_logoLink__qgtkp {
  text-decoration: none;
  color: inherit;
  cursor: pointer;
}

.Header_logoLink__qgtkp:hover {
  text-decoration: none;
  color: inherit;
}

.Header_mobileDrawer__Qh8uH a {
  text-decoration: none;
}

.Header_mobileDrawer__Qh8uH a:hover {
  text-decoration: none;
}

@media (max-width: 768px) {
  .Header_navContainer__Y0LlM {
    display: none;
    flex-direction: column;
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.9);
  }

  .Header_mobileMenuOpen__ma2v4 {
    display: flex;
  }

  .Header_navList__FI4e0 {
    flex-direction: column;
  }

  .Header_navItem__woy74 {
    margin: 10px 0;
  }

  .Header_hamburger__gyFYw {
    display: flex;
    order: 2;
  }

  .Header_ctaButton__rqx4i {
    display: none;
  }

  .Header_submenuPanel__Et6vL {
    display: none;
  }

  .Header_submenuContent__gO5TN {
    flex-direction: column;
  }

  .Header_submenuColumn__gc\\+LL {
    margin-bottom: 20px;
  }
}

@keyframes Header_jump__Ul--R {
  0%,
  100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
}

@keyframes Header_slideIn__qNk38 {
  from {
    opacity: 0;
    transform: translateX(-20px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Header.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,kDAAkD;AACpD;;AAEA;EACE,4BAA4B;EAC5B,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sCAAsC;EACtC,mCAA2B;UAA3B,2BAA2B;EAC3B,eAAe;EACf,yEAAiE;EAAjE,iEAAiE;EAAjE,oGAAiE;AACnE;;AAEA;EACE,6BAAqB;UAArB,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,8CAAsC;UAAtC,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,0DAA4C;EAC5C,6BAA6B;AAC/B;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;IAC5B,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,yBAAyB;IACzB,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,eAAe;EACf,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,WAAW;EACX,mDAAmD;AACrD;;AAEA;;EAEE,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;EACjB,WAAW;EACX,cAAc;EACd,aAAa;EACb,iDAAmC;AACrC;;AAEA;EACE,SAAO;EACP,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mCAAmC;EACnC,8BAA8B;EAC9B,YAAY;EACZ,mBAAmB;EACnB,wCAAwC;EACxC,iCAAiC;EACjC,eAAe;EACf,6CAA6C;AAC/C;;AAEA;EACE,0CAA0C;EAC1C,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,SAAS,EAAE,qBAAqB;EAChC,WAAW,EAAE,qBAAqB;AACpC;;AAEA;EACE,aAAa,EAAE,kCAAkC;AACnD;;AAEA;EACE,WAAW;EACX,WAAW;EACX,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,oCAAoC;EACtC;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,QAAQ;EACV;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;;IAEE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF","sourcesContent":[".headerWrapper {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 100;\n  transition: opacity 0.3s ease, transform 0.5s ease;\n}\n\n.headerWrapper.hidden {\n  transform: translateY(-100%);\n  opacity: 0;\n}\n\n.headerWrapper.expanded {\n  height: auto;\n  transition: none;\n}\n\n.header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  background-color: rgba(0, 0, 0, 0.845);\n  backdrop-filter: blur(15px);\n  padding: 10px 0;\n  transition: background-color 0.3s ease, backdrop-filter 0.3s ease;\n}\n\n.headerWrapper.expanded .header:not(.submenuVisible) {\n  backdrop-filter: none;\n  background-color: transparent;\n}\n\n.submenuVisible {\n  backdrop-filter: blur(15px) !important;\n}\n\n.headerContent {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 20px;\n}\n\n.logo {\n  display: inline-flex;\n  align-items: baseline;\n  color: white;\n  font-size: 20px;\n  font-weight: bold;\n  line-height: 1;\n}\n\n.logoAccent {\n  color: #4da3ff;\n}\n\n.logoWord {\n  display: inline-block;\n  overflow: hidden;\n  white-space: nowrap;\n  line-height: 1;\n  animation: logoReveal 0.7s ease-out forwards;\n  transform-origin: left center;\n}\n\n@keyframes logoReveal {\n  from {\n    opacity: 0;\n    clip-path: inset(0 100% 0 0);\n    transform: translateX(-10px);\n  }\n  to {\n    opacity: 1;\n    clip-path: inset(0 0 0 0);\n    transform: translateX(0);\n  }\n}\n\n.navContainer {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  padding-bottom: 2px;\n}\n\n.navList {\n  list-style: none;\n  display: flex;\n  margin: 0;\n  padding: 0;\n}\n\n.navItem {\n  margin: 0px 15px;\n  transition: opacity 0.3s ease;\n}\n\n.navLink {\n  color: #fff;\n  text-decoration: none;\n  font-size: 14px;\n  transition: color 0.3s;\n  cursor: pointer;\n}\n\n.navItem.dimmed .navLink {\n  color: #999;\n}\n\n.navLink:hover {\n  color: #fff;\n}\n\n.navItem:hover .navLink {\n  color: #fff;\n}\n\n.submenuPanel {\n  background-color: rgba(0, 0, 0, 0);\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  z-index: 99;\n  transition: opacity 0.3s ease, visibility 0.3s ease;\n}\n\n.submenuPanel:hover,\n.navContainer:hover {\n  visibility: visible;\n  opacity: 1;\n}\n\n.submenuPanel.visible {\n  visibility: visible;\n  opacity: 1;\n}\n\n.headerWrapper.expanded:hover + .content-wrapper {\n  transform: translateY(50px);\n}\n\n.submenuContent {\n  display: flex;\n  justify-content: space-between;\n  max-width: 1200px;\n  width: 100%;\n  margin: 0 auto;\n  padding: 20px;\n  animation: slideIn 0.3s ease-in-out;\n}\n\n.submenuColumn {\n  flex: 1;\n  padding: 0 15px;\n}\n\n.submenuColumn h3 {\n  color: #fff;\n  font-size: 14px;\n  margin-bottom: 10px;\n  font-weight: bold;\n}\n\n.submenuColumn ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.submenuColumn li {\n  margin-bottom: 8px;\n}\n\n.submenuColumn a {\n  color: #ccc;\n  text-decoration: none;\n  font-size: 14px;\n  transition: color 0.3s;\n}\n\n.submenuColumn a:hover {\n  color: #fff;\n}\n\n.ctaButton {\n  background-color: var(--color-text);\n  color: var(--color-background);\n  border: none;\n  border-radius: 25px;\n  padding: var(--space-xs) var(--space-sm);\n  font-size: var(--font-size-small);\n  cursor: pointer;\n  transition: background-color 0.3s, color 0.3s;\n}\n\n.ctaButton:hover {\n  background-color: var(--color-text-subtle);\n  color: var(--color-background);\n}\n\n.hamburger {\n  display: none;\n  flex-direction: column;\n  justify-content: space-around;\n  width: 25px;\n  height: 20px;\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n  z-index: 110;\n  position: absolute;\n  top: 15px; /* Adjust as needed */\n  right: 20px; /* Adjust as needed */\n}\n\n.closeIcon {\n  z-index: 2000; /* Ensure it is above the drawer */\n}\n\n.hamburgerIcon {\n  width: 100%;\n  height: 2px;\n  background-color: white;\n  transition: all 0.3s linear;\n}\n\n.logoLink {\n  text-decoration: none;\n  color: inherit;\n  cursor: pointer;\n}\n\n.logoLink:hover {\n  text-decoration: none;\n  color: inherit;\n}\n\n.mobileDrawer a {\n  text-decoration: none;\n}\n\n.mobileDrawer a:hover {\n  text-decoration: none;\n}\n\n@media (max-width: 768px) {\n  .navContainer {\n    display: none;\n    flex-direction: column;\n    position: absolute;\n    top: 100%;\n    left: 0;\n    right: 0;\n    background-color: rgba(0, 0, 0, 0.9);\n  }\n\n  .mobileMenuOpen {\n    display: flex;\n  }\n\n  .navList {\n    flex-direction: column;\n  }\n\n  .navItem {\n    margin: 10px 0;\n  }\n\n  .hamburger {\n    display: flex;\n    order: 2;\n  }\n\n  .ctaButton {\n    display: none;\n  }\n\n  .submenuPanel {\n    display: none;\n  }\n\n  .submenuContent {\n    flex-direction: column;\n  }\n\n  .submenuColumn {\n    margin-bottom: 20px;\n  }\n}\n\n@keyframes jump {\n  0%,\n  100% {\n    transform: scale(1);\n  }\n  50% {\n    transform: scale(1.1);\n  }\n}\n\n@keyframes slideIn {\n  from {\n    opacity: 0;\n    transform: translateX(-20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"headerWrapper": `Header_headerWrapper__tkOPg`,
	"hidden": `Header_hidden__bI9VI`,
	"expanded": `Header_expanded__9kFsl`,
	"header": `Header_header__Lhnr8`,
	"submenuVisible": `Header_submenuVisible__k-PId`,
	"headerContent": `Header_headerContent__WRnni`,
	"logo": `Header_logo__nZ7K6`,
	"logoAccent": `Header_logoAccent__oKBRX`,
	"logoWord": `Header_logoWord__LmzqP`,
	"logoReveal": `Header_logoReveal__cekmW`,
	"navContainer": `Header_navContainer__Y0LlM`,
	"navList": `Header_navList__FI4e0`,
	"navItem": `Header_navItem__woy74`,
	"navLink": `Header_navLink__v1a7F`,
	"dimmed": `Header_dimmed__zveC9`,
	"submenuPanel": `Header_submenuPanel__Et6vL`,
	"visible": `Header_visible__jJT3+`,
	"content-wrapper": `Header_content-wrapper__BTI-b`,
	"submenuContent": `Header_submenuContent__gO5TN`,
	"slideIn": `Header_slideIn__qNk38`,
	"submenuColumn": `Header_submenuColumn__gc+LL`,
	"ctaButton": `Header_ctaButton__rqx4i`,
	"hamburger": `Header_hamburger__gyFYw`,
	"closeIcon": `Header_closeIcon__P5RSh`,
	"hamburgerIcon": `Header_hamburgerIcon__b8hAl`,
	"logoLink": `Header_logoLink__qgtkp`,
	"mobileDrawer": `Header_mobileDrawer__Qh8uH`,
	"mobileMenuOpen": `Header_mobileMenuOpen__ma2v4`,
	"jump": `Header_jump__Ul--R`
};
export default ___CSS_LOADER_EXPORT___;
